import { render } from "./ContainerPayableArea.vue?vue&type=template&id=22c4180a&scoped=true&ts=true"
import script from "./ContainerPayableArea.vue?vue&type=script&lang=ts"
export * from "./ContainerPayableArea.vue?vue&type=script&lang=ts"

import "./ContainerPayableArea.vue?vue&type=style&index=0&id=22c4180a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c4180a"]])

export default __exports__